import {
  BookOpen,
  CalendarDays,
  CircleUserRound,
  ChartGantt,
  Clock,
  FileText,
  FolderOpen,
  Gauge,
  PackageCheck,
  Scale,
  Settings,
  ShieldAlert,
  Target,
  Wallet,
  type LucideIcon,
} from 'lucide-react';
import type { Capability } from './types';

export interface NavItem {
  path: string;
  label: string;
  icon: LucideIcon;
  /** Sprint that delivers the tab (spec module map). Tabs not built yet show a placeholder. */
  sprint: number;
  /** Shown only when the member holds this capability. Display only; the API re-checks. */
  requires?: Capability;
  description: string;
}

export const NAV: NavItem[] = [
  {
    path: 'my-work',
    label: 'My work',
    icon: CircleUserRound,
    sprint: 1,
    description: 'What is due, overdue or blocked for you.',
  },
  {
    path: 'executive',
    label: 'Executive',
    icon: Gauge,
    sprint: 2,
    description:
      'Program health, phase cards, what needs the committee, the timeline, risks, spend and success criteria.',
  },
  {
    path: 'tracker',
    label: 'Tracker',
    icon: ChartGantt,
    sprint: 1,
    description: 'Roadmap, board, list, phase pages, task panel and my work.',
  },
  {
    path: 'deliverables',
    label: 'Deliverables',
    icon: PackageCheck,
    sprint: 1,
    description: 'The deliverable register with lifecycle, acceptance and version history.',
  },
  {
    path: 'documents',
    label: 'Documents',
    icon: FolderOpen,
    sprint: 1,
    description: 'Every file, tied to phases, tasks and deliverables.',
  },
  {
    path: 'raid',
    label: 'RAID',
    icon: ShieldAlert,
    sprint: 2,
    description: 'Risks, assumptions, issues, decisions and dependencies with scoring and a heat map.',
  },
  {
    path: 'reports',
    label: 'Reports',
    icon: FileText,
    sprint: 2,
    description: 'Generate, narrate, publish and archive the governance reporting.',
  },
  {
    path: 'meetings',
    label: 'Meetings',
    icon: CalendarDays,
    sprint: 3,
    description: 'Steering Committee and working sessions, minutes, action items and decisions.',
  },
  {
    path: 'criteria',
    label: 'Success Criteria',
    icon: Target,
    sprint: 3,
    description: 'The success criteria with status and evidence.',
  },
  {
    path: 'budget',
    label: 'Budget',
    icon: Wallet,
    sprint: 4,
    requires: 'budget.read',
    description:
      'Implementation costs (technology, staffing and other) as they come out of the vendor evaluation. Never BlackWolf fees.',
  },
  {
    path: 'vendors',
    label: 'Vendors',
    icon: Scale,
    sprint: 4,
    description: 'Evaluation scorecards across the technology categories.',
  },
  {
    path: 'work-record',
    label: 'Work Record',
    icon: Clock,
    sprint: 3,
    requires: 'workrecord.manage',
    description: 'Monthly work log, expense pre-approvals, invoices and the engagement term.',
  },
  {
    path: 'admin',
    label: 'Admin',
    icon: Settings,
    sprint: 0,
    requires: 'admin.manage',
    description: 'Users, roles, invitations, settings and the audit log.',
  },
  {
    path: 'guide',
    label: 'Guide',
    icon: BookOpen,
    sprint: 6,
    description: 'Step-by-step instructions for every tab you use.',
  },
];

/** Tabs available today. */
export const BUILT = new Set([
  'guide',
  'my-work',
  'executive',
  'tracker',
  'deliverables',
  'documents',
  'raid',
  'reports',
  'criteria',
  'meetings',
  'vendors',
  'budget',
  'work-record',
  'admin',
]);
